import { Injectable, SecurityContext, inject } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({ providedIn: 'root' })
export class AssessmentSanitizerService {
  private readonly sanitizer = inject(DomSanitizer);

  public getSanitizedDescription(description: string) {
    // The description of an assessment can contain HTML.
    const sanitized = this.sanitizer.sanitize(SecurityContext.HTML, description);

    /*
     * In order to have control over styles, text-overflow for example,
     * we need to extract the textContent from the markup in the description. This is specifically for the
     * description that's displayed in the list view.
     */
    const tempElement = document.createElement('div');
    tempElement.innerHTML = sanitized as string;
    return tempElement.textContent ?? '';
  }
}
